module.exports = __webpack_public_path__ + "static/media/LexendDeca-Regular.47e7cf64.ttf";